import { relations } from "drizzle-orm";
import {
  pgTable,
  text,
  timestamp,
  integer,
  index,
  uniqueIndex,
  primaryKey,
} from "drizzle-orm/pg-core";

import { items } from "./surveys";

export const structureArea = pgTable(
  "structure_area",
  {
    id: text("id").primaryKey(),
    name: text("name").notNull(),
    sortOrder: integer("sort_order").default(0).notNull(),
    createdAt: timestamp("created_at").defaultNow().notNull(),
    updatedAt: timestamp("updated_at")
      .defaultNow()
      .$onUpdate(() => /* @__PURE__ */ new Date())
      .notNull(),
  },
  (table) => [
    uniqueIndex("structure_area_name_unique").on(table.name),
    index("structure_area_sort_order_idx").on(table.sortOrder),
  ],
);

export const structureItem = pgTable(
  "structure_item",
  {
    id: text("id").primaryKey(),
    structureAreaId: text("structure_area_id")
      .notNull()
      .references(() => structureArea.id, { onDelete: "cascade" }),
    atomicItemId: text("atomic_item_id")
      .notNull()
      .references(() => items.id, { onDelete: "restrict" }),
    sortOrder: integer("sort_order").default(0).notNull(),
    createdAt: timestamp("created_at").defaultNow().notNull(),
    updatedAt: timestamp("updated_at")
      .defaultNow()
      .$onUpdate(() => /* @__PURE__ */ new Date())
      .notNull(),
  },
  (table) => [
    uniqueIndex("structure_item_area_atomic_unique").on(
      table.structureAreaId,
      table.atomicItemId,
    ),
    index("structure_item_area_id_idx").on(table.structureAreaId),
    index("structure_item_atomic_item_id_idx").on(table.atomicItemId),
  ],
);

export const structureAreaRelations = relations(structureArea, ({ many }) => ({
  items: many(structureItem),
}));

export const structureItemRelations = relations(structureItem, ({ one }) => ({
  area: one(structureArea, {
    fields: [structureItem.structureAreaId],
    references: [structureArea.id],
  }),
  atomicItem: one(items, {
    fields: [structureItem.atomicItemId],
    references: [items.id],
  }),
}));

export const structureChip = pgTable(
  "structure_chips",
  {
    id: text("id").primaryKey(),
    label: text("label").notNull(),
    category: text("category"),
    createdAt: timestamp("created_at").defaultNow().notNull(),
  },
  (table) => [uniqueIndex("structure_chips_label_unique").on(table.label)],
);

export const structureAreaChip = pgTable(
  "structure_area_chips",
  {
    areaId: text("area_id")
      .notNull()
      .references(() => structureArea.id, { onDelete: "cascade" }),
    chipId: text("chip_id")
      .notNull()
      .references(() => structureChip.id, { onDelete: "cascade" }),
  },
  (table) => [
    primaryKey({ columns: [table.areaId, table.chipId] }),
    index("structure_area_chips_area_id_idx").on(table.areaId),
    index("structure_area_chips_chip_id_idx").on(table.chipId),
  ],
);

export const structureItemChip = pgTable(
  "structure_item_chips",
  {
    itemId: text("item_id")
      .notNull()
      .references(() => structureItem.id, { onDelete: "cascade" }),
    chipId: text("chip_id")
      .notNull()
      .references(() => structureChip.id, { onDelete: "cascade" }),
  },
  (table) => [
    primaryKey({ columns: [table.itemId, table.chipId] }),
    index("structure_item_chips_item_id_idx").on(table.itemId),
    index("structure_item_chips_chip_id_idx").on(table.chipId),
  ],
);
